import formModuleReducer from "./formModules";

const FormModuleRedux = {
  formModuleReducer,
};

export default FormModuleRedux;
